module.exports = __webpack_public_path__ + "static/with-plans.df3ccbf3.jpg";